import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Users, Star, Sparkles, Award, Zap } from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import { teamMembers } from "./data";

const TeamMemberCard = ({ member, index }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    return (
        <AnimatedSection delay={0.1 * index}>
            <motion.div
                className="relative group h-full perspective-1000"
                onMouseEnter={() => setIsFlipped(true)}
                onMouseLeave={() => setIsFlipped(false)}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
            >
                {/* Glow Effect Background */}
                {/* <motion.div
                    className="absolute -inset-6 opacity-0 group-hover:opacity-100 transition-opacity duration-700"
                    animate={{
                        background: [
                            'radial-linear(circle at 50% 50%, rgba(59, 130, 246, 0.15), transparent 70%)',
                            'radial-linear(circle at 50% 50%, rgba(6, 182, 212, 0.15), transparent 70%)',
                            'radial-linear(circle at 50% 50%, rgba(59, 130, 246, 0.15), transparent 70%)',
                        ]
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "linear"
                    }}
                /> */}

                {/* Main Card Container */}
                <motion.div
                    className="relative bg-linear-to-br from-gray-900/90 via-gray-900/70 to-gray-800/90 backdrop-blur-2xl rounded-3xl border border-gray-700/50 group-hover:border-blue-500/50 shadow-2xl overflow-hidden h-full"
                    // animate={isFlipped ? { rotateY: 180 } : { rotateY: 0 }}
                    transition={{ duration: 0.6, type: "spring" }}
                    style={{ transformStyle: "preserve-3d" }}
                >
                    {/* Animated Border linear */}
                    <motion.div
                        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                        style={{
                            background: 'linear-linear(90deg, transparent, rgba(59, 130, 246, 0.3), transparent)',
                            backgroundSize: '200% 100%',
                        }}
                        animate={{
                            backgroundPosition: ['200% 0', '-200% 0'],
                        }}
                        transition={{
                            duration: 3,
                            repeat: Infinity,
                            ease: "linear"
                        }}
                    />

                    {/* Holographic Effect Overlay */}
                    {/* <div className="absolute inset-0 bg-linear-to-br from-blue-500/5 via-transparent to-cyan-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" /> */}

                    {/* Card Front */}
                    <div
                        className="relative w-full h-full p-8 backface-hidden"
                        style={{ backfaceVisibility: 'hidden' }}
                    >
                        {/* Particle Effects around Image */}
                        {/* <div className="absolute top-8 left-1/2 -translate-x-1/2 w-56 h-56">
                            {[...Array(8)].map((_, i) => (
                                <motion.div
                                    key={i}
                                    className="absolute w-2 h-2 rounded-full bg-blue-400/60"
                                    style={{
                                        left: '50%',
                                        top: '50%',
                                    }}
                                    animate={{
                                        x: [0, Math.cos((i * Math.PI * 2) / 8) * 80],
                                        y: [0, Math.sin((i * Math.PI * 2) / 8) * 80],
                                        opacity: [0, 0.8, 0],
                                        scale: [0, 1.5, 0],
                                    }}
                                    transition={{
                                        duration: 2,
                                        repeat: Infinity,
                                        delay: i * 0.2,
                                        ease: "easeOut"
                                    }}
                                />
                            ))}
                        </div> */}

                        {/* Image Container with Glass Effect */}
                        <div className="relative w-55 h-55 mx-auto mb-6">
                            {/* Pulsing linear Background */}
                            {/* <motion.div
                                animate={{
                                    scale: [1, 1.15, 1],
                                    opacity: [0.3, 0.6, 0.3],
                                    rotate: [0, 180, 360],
                                }}
                                transition={{
                                    duration: 4,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                                className="absolute -inset-6 bg-linear-to-r from-blue-500/40 via-cyan-500/40 to-purple-500/40 rounded-full blur-2xl"
                            /> */}

                            {/* Rotating Ring */}
                            {/* <motion.div
                                animate={{
                                    rotate: 360,
                                }}
                                transition={{
                                    duration: 8,
                                    repeat: Infinity,
                                    ease: "linear"
                                }}
                                className="absolute -inset-3 rounded-full"
                                style={{
                                    background: 'conic-linear(from 0deg, transparent, rgba(59, 130, 246, 0.5), transparent)',
                                }}
                            /> */}

                            {/* Glass Border */}
                            {/* <div className="absolute -inset-2 rounded-full bg-linear-to-br from-white/20 via-white/5 to-transparent backdrop-blur-sm border border-white/10" /> */}

                            {/* Image */}
                            <div className="relative w-full aspect-[4/5] max-w-[200px] mx-auto rounded-xl overflow-hidden border-4 border-gray-800/50 shadow-2xl group-hover:border-blue-500/30 transition-all duration-500">
                                <motion.img
                                    src={member.photo}
                                    alt={member.name}
                                    className="w-full h-full object-cover absolute "
                                    style={{ objectPosition: 'center center' }}
                                    whileHover={{ scale: 1.1 }}
                                    transition={{ duration: 0.5 }}
                                />

                                {/* Shimmer Effect */}
                                <motion.div
                                    className="absolute inset-0 bg-linear-to-r from-transparent via-white/20 to-transparent"
                                    animate={{
                                        x: ['-200%', '200%'],
                                    }}
                                    transition={{
                                        duration: 2,
                                        repeat: Infinity,
                                        repeatDelay: 3,
                                        ease: "easeInOut"
                                    }}
                                />
                            </div>

                            {/* Status Badge */}
                            {/* <motion.div
                                className="absolute -bottom-2 left-1/2 -translate-x-1/2 px-4 py-1.5 rounded-full bg-linear-to-r from-emerald-500 to-cyan-500 shadow-lg"
                                whileHover={{ scale: 1.1 }}
                            >
                                <div className="flex items-center gap-2">
                                    <motion.div
                                        animate={{
                                            scale: [1, 1.2, 1],
                                            opacity: [1, 0.5, 1],
                                        }}
                                        transition={{
                                            duration: 2,
                                            repeat: Infinity,
                                        }}
                                        className="w-2 h-2 bg-white rounded-full"
                                    />
                                    <span className="text-white text-xs font-bold">Disponible</span>
                                </div>
                            </motion.div> */}

                        </div>

                        {/* Role Badge */}
                        {/* <motion.div
                            className="flex justify-center items-center gap-2 px-5 py-2 rounded-full bg-linear-to-r from-blue-500/20 to-cyan-500/20 border border-blue-500/30 mb-4 backdrop-blur-sm"
                            whileHover={{ scale: 1.05 }}
                        >
                            {React.createElement(member.icon, { className: "w-4 h-4 text-blue-400" })}
                            <span className="text-blue-300 text-sm font-semibold uppercase tracking-wider">{member.role}</span>
                        </motion.div> */}

                        {/* Name */}
                        <h3 className="text-3xl font-bold text-white mt-10 mb-3 text-center bg-linear-to-r from-white via-blue-100 to-white bg-clip-text">
                            {member.name}
                        </h3>

                        {/* Expertise & Experience Tags */}
                        <div className="flex flex-wrap justify-center gap-2 mb-5">
                            <motion.div
                                className="px-4 py-2 rounded-xl bg-linear-to-r from-gray-800/80 to-gray-700/80 backdrop-blur-sm border border-gray-600/50 text-gray-200 text-sm font-medium"
                                whileHover={{ scale: 1.05, borderColor: 'rgba(59, 130, 246, 0.5)' }}
                            >
                                {member.expertise}
                            </motion.div>
                            {/* <motion.div
                                className="px-4 py-2 rounded-xl bg-linear-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 text-cyan-400 text-sm font-bold"
                                whileHover={{ scale: 1.05 }}
                            >
                                ⚡ {member.experience}
                            </motion.div> */}
                        </div>

                        {/* Description */}
                        <p className="text-gray-300 text-sm text-center leading-relaxed mb-6 px-2">
                            {member.description}
                        </p>

                        {/* Stats */}
                        {/* <div className="flex items-center justify-center gap-8 pt-6 border-t border-gray-700/50">
                            <motion.div
                                className="text-center"
                                whileHover={{ scale: 1.1 }}
                            >
                                <div className="text-3xl font-bold bg-linear-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">{member.projects}+</div>
                                <div className="text-xs text-gray-500 font-medium mt-1">Projets</div>
                            </motion.div>

                            <div className="w-px h-12 bg-linear-to-b from-transparent via-gray-700 to-transparent" />

                            <motion.div
                                className="text-center"
                                whileHover={{ scale: 1.1 }}
                            >
                                <div className="flex items-center justify-center gap-0.5 mb-1">

                                    {[...Array(5)].map((_, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: i * 0.1 }}
                                        >
                                            <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
                                        </motion.div>
                                    ))}

                                </div>

                                <div className="text-xs text-gray-500 font-medium">Excellence</div>
                            </motion.div>
                        </div> */}

                        {/* Hover Indicator */}
                        {/* <motion.div
                            className="absolute bottom-4 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                            animate={{ y: [0, 5, 0] }}
                            transition={{ duration: 1.5, repeat: Infinity }}
                        >
                            <div className="text-xs text-blue-400 font-medium flex items-center gap-1">
                                <Sparkles className="w-3 h-3" />
                                Survolez pour plus d'infos
                            </div>
                        </motion.div> */}

                    </div>

                    {/* Card Back (Revealed on Hover) */}
                    {/* <div
                        className="absolute inset-0 p-8 backface-hidden bg-linear-to-br from-blue-900/20 via-gray-900/90 to-cyan-900/20"
                        style={{
                            backfaceVisibility: 'hidden',
                            transform: 'rotateY(180deg)'
                        }}
                    >
                        <div className="flex flex-col items-center justify-center h-full">
                            <motion.div
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={isFlipped ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
                                transition={{ delay: 0.2 }}
                            >
                                <Award className="w-16 h-16 text-blue-400 mb-6" />

                                <h4 className="text-2xl font-bold text-white mb-4">Compétences Clés</h4>

                                <div className="space-y-3 mb-6">
                                    {['Leadership Technique', 'Innovation', 'Architecture Cloud', 'Mentorat'].map((skill, i) => (
                                        <motion.div
                                            key={skill}
                                            initial={{ opacity: 0, x: -20 }}
                                            // animate={isFlipped ? { opacity: 1, x: 0 } : { opacity: 0, x: -20 }}
                                            transition={{ delay: 0.3 + i * 0.1 }}
                                            className="flex items-center gap-3 px-4 py-2 rounded-lg bg-gray-800/50 border border-gray-700/50"
                                        >
                                            <Zap className="w-4 h-4 text-cyan-400" />
                                            <span className="text-gray-200 text-sm">{skill}</span>
                                        </motion.div>
                                    ))}
                                </div>

                                <motion.div
                                    className="text-center p-4 rounded-xl bg-linear-to-r from-blue-500/10 to-cyan-500/10 border border-blue-500/20"
                                    whileHover={{ scale: 1.05 }}
                                >
                                    <p className="text-blue-300 text-sm italic">
                                        "L'excellence est un voyage, pas une destination"
                                    </p>

                                </motion.div>

                            </motion.div>

                        </div>

                    </div> */}

                </motion.div>

            </motion.div>

        </AnimatedSection>

    );

};


const TeamGrid = () => {

    return (

        <section className="relative py-20 ">

            <div className="absolute inset-0">

                {[...Array(40)].map((_, i) => (
                    <motion.div
                        key={i}
                        animate={{
                            y: [0, -100, 0],
                            x: [0, Math.sin(i) * 50, 0],
                            opacity: [0.1, 0.3, 0.1],
                        }}
                        transition={{
                            duration: 10 + i,
                            repeat: Infinity,
                            delay: i * 0.5,
                            ease: "linear"
                        }}
                        className="absolute w-32 h-32 rounded-full blur-xl bg-linear-to-r from-blue-500/5 to-cyan-500/5"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                    />
                ))}

            </div>

            <div className="relative z-10 max-w-8xl mx-auto px-6 md:px-20">
                <AnimatedSection delay={0.2}>
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-linear-to-r from-blue-900/20 to-cyan-900/20 border border-blue-500/20 mb-6">
                            <Users className="w-5 h-5 text-blue-400" />
                            <span className="text-blue-300 font-medium">Toute l'Équipe</span>
                        </div>

                        <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6">
                            Rencontrez nos<span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">Experts</span>
                        </h2>

                        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                            Une équipe passionnée dédiée à votre réussite technologique
                        </p>
                    </div>
                </AnimatedSection>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                    {teamMembers.map((member, index) => (
                        <TeamMemberCard key={member.id} member={member} index={index} />
                    ))}
                </div>

                {/* <AnimatedSection delay={0.6}>
                    <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
                        <motion.div
                            className="bg-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-700 p-6 text-center group hover:border-blue-500/50 transition-all duration-300"
                            whileHover={{ y: -5, scale: 1.02 }}
                        >
                            <div className="text-3xl font-bold bg-linear-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-2">{teamMembers.length}</div>
                            <div className="text-sm text-gray-400">Experts dédiés</div>
                        </motion.div>

                        <motion.div
                            className="bg-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-700 p-6 text-center group hover:border-emerald-500/50 transition-all duration-300"
                            whileHover={{ y: -5, scale: 1.02 }}
                        >
                            <div className="text-3xl font-bold bg-linear-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent mb-2">40+</div>
                            <div className="text-sm text-gray-400">Années d'expérience</div>
                        </motion.div>

                        <motion.div
                            className="bg-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-700 p-6 text-center group hover:border-purple-500/50 transition-all duration-300"
                            whileHover={{ y: -5, scale: 1.02 }}
                        >
                            <div className="text-3xl font-bold bg-linear-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-2">65+</div>
                            <div className="text-sm text-gray-400">Projets réalisés</div>
                        </motion.div>

                        <motion.div
                            className="bg-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-700 p-6 text-center group hover:border-amber-500/50 transition-all duration-300"
                            whileHover={{ y: -5, scale: 1.02 }}
                        >
                            <div className="text-3xl font-bold bg-linear-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent mb-2">98%</div>
                            <div className="text-sm text-gray-400">Clients satisfaits</div>
                        </motion.div>
                    </div>
                </AnimatedSection> */}
            </div>
        </section>
    );
};

export default TeamGrid;
